const sign = (v, d = 2, pre = "$") => (v == null ? "—" : `${v >= 0 ? "+" : "-"}${pre}${Math.abs(v).toFixed(d)}`);
const cls = (v) => (v == null ? "" : v >= 0 ? "desk-up" : "desk-down");

const Box = ({ k, v, c, id }) => (
  <div className="desk-box"><div className="k">{k}</div><div className={`v ${c || ""}`} data-testid={id}>{v}</div></div>
);

export const GoldPanel = ({ m }) => (
  <section className="desk-card half-lg" data-testid="desk-gold">
    <h2>Gold</h2>
    <div className="desk-mono font-semibold leading-none" style={{ fontSize: "clamp(22px,6.5vw,36px)" }} data-testid="desk-price">{m.price ? `$${m.price.toFixed(2)}` : "—"}</div>
    <div className={`desk-mono text-lg mt-2 ${cls(m.change_usd)}`} data-testid="desk-change">
      {sign(m.change_usd)} {m.change_pct == null ? "" : `(${m.change_pct >= 0 ? "+" : ""}${m.change_pct}%)`}
    </div>
    <div className="text-sm text-[color:var(--mute)] mt-1">{m.market_open === false ? "Market closed" : "Today"}{m.price_at ? ` · ${new Date(m.price_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}` : ""}</div>
  </section>
);

export const GoldStats = ({ m, s }) => (
  <section className="desk-card" data-testid="desk-gold-stats">
    <h2>Volatility</h2>
    {m.spike && <div className="mb-3 p-3 rounded-lg bg-[rgba(240,162,2,.12)] text-[color:var(--amber)] text-base font-semibold" data-testid="desk-spike">Spike: {m.spike_reason}</div>}
    <div className="desk-stats">
      <Box k="5-min move" v={sign(m.move_5m)} c={cls(m.move_5m)} id="desk-move5" />
      <Box k="1-hour move" v={sign(m.move_1h)} c={cls(m.move_1h)} id="desk-move1h" />
      <Box k="ATR (5m)" v={m.atr14 == null ? "—" : `$${m.atr14}`} id="desk-atr" />
      <Box k="ATR vs avg" v={m.atr_ratio == null ? "—" : `${m.atr_ratio}x`} c={m.atr_ratio > s.atr_mult ? "desk-down" : ""} id="desk-atr-ratio" />
    </div>
  </section>
);
